import styled from 'styled-components';

import { Grid as SemanticGrid } from 'semantic-ui-react';

const Container = styled.div`
  width: 100%;
  min-width: 350px;
`;

const Column = styled(SemanticGrid.Column)`
  min-width: 200px;
`;

const CardRow = styled(SemanticGrid.Row)``;

const Grid = styled(SemanticGrid)`
  &.ui.grid {
    margin-top: 0px;
  }
  &.ui.grid .row {
    padding-top: 0px;
    padding-bottom: 25px;
  }
`;

export {
  Container,
  Column,
  CardRow,
  Grid,
};
